
<h2 class="comp-title">Autocomplete</h2>

<!-- <form [formGroup]="myForm" class="example-form">
    <mat-form-field class="example-full-width">
        <input type="text" placeholder="בחר אופציה" aria-label="Number" matInput formControlName="myControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of options" [value]="option"> {{option}} </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</form> -->


<form class="example-form">
    <mat-form-field class="example-full-width">
      <mat-label>הקלד עיר</mat-label>
      <input type="text"
             placeholder=""
             aria-label="Number"
             matInput
             [formControl]="myControl"
             [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
